// extracted by mini-css-extract-plugin
export var backdropBlur = "_84-0";
export var body = "_84-5";
export var bodyScroll = "_84-6";
export var columnFooter = "_84-7";
export var columnFooterFlush = "_84-8";
export var contentColumn = "_84-4";
export var frame = "_84-3";
export var heroContent = "_84-c";
export var heroOverlay = "_84-b";
export var image = "_84-a";
export var imageWrapper = "_84-9";
export var modal = "_84-1";
export var modalMain = "_84-2";
export var productHeader = "_84-d";
export var productHeaderIcon = "_84-e";
export var productHeaderName = "_84-f";
export var progressIndicator = "_84-g";